module.exports = __webpack_public_path__ + "img/flower_leaf_21.b507cdad.png";